module.exports = __webpack_public_path__ + "img/logo.803110c7.png";